export var allowedFrameAttributes = new Set([
    'className',
    'title',
    'height',
    'width',
    'scrolling',
    'allow'
]);
export var isAllowedFrameAttribute = function (key) {
    return allowedFrameAttributes.has(key);
};
